import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"
import loader from "./../../../../assets/loading/loader.gif"

const EditProducerLoan = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLoading, setPageLoading] = useState(true)
  const [loan, setLoan] = useState(null)
  const [centers, setCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [vlccs, setVlccs] = useState([])
  const [producers, setProducers] = useState([])

  useEffect(() => {
    const getInfo = async () => {
      try {
        const [loanResp, chilResp, rouResp, ccResp, proResp] = await Promise.all([
          api.get("producer-loan/" + id), api.get("centers"), api.get("routes"), api.get("collection-centers"), api.get("producers")
        ])
        setLoan(loanResp.data.data?.[0] || loanResp.data.data)
        setCenters(Array.isArray(chilResp.data.data) ? chilResp.data.data : chilResp.data.data?.data || [])
        setRoutes(Array.isArray(rouResp.data.data) ? rouResp.data.data : rouResp.data.data?.data || [])
        setVlccs(Array.isArray(ccResp.data.data) ? ccResp.data.data : ccResp.data.data?.data || [])
        setProducers(Array.isArray(proResp.data.data) ? proResp.data.data : proResp.data.data?.data || [])
      } catch (err) { console.error(err) }
      setPageLoading(false)
    }; getInfo()
  }, [id])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try { const r = await api.put("update-producer-loan/" + id, values); if (r.data.success) { setSubmitted(true); setTimeout(() => setSubmitted(false), 3000) } } catch (e) { console.error(e) }
    setLoading(false)
  }

  if (pageLoading) return <div className="dashBody"><img className="loaderImg" src={loader} alt="Loading" /></div>
  if (!loan) return <div className="dashBody"><p>Loan not found</p></div>

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row><Col md={6}><h4>Edit Producer Loan</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}><Link to="/producer-loans" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col></Row>
      </div>
      <div className="dashContent">
        <AvForm className="form-horizontal" onValidSubmit={handleValidSubmit}>
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="chillingCenter" label="Chilling Center *" required value={String(loan.chillingCenter)}>
              <option value="">Select CC</option>{centers.map((c, i) => <option key={i} value={String(c.id)}>{c.name}</option>)}</AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="route" label="Route *" required value={String(loan.route)}>
              <option value="">Select Route</option>{routes.map((r, i) => <option key={i} value={String(r.id)}>{r.routeName}</option>)}</AvField></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField type="select" name="vlcc" label="VLCC *" required value={String(loan.vlcc)}>
              <option value="">Select VLCC</option>{vlccs.map((v, i) => <option key={i} value={String(v.id)}>{v.centerName}</option>)}</AvField></div></Col>
            <Col md={6}><div className="mb-3"><AvField type="select" name="producer" label="Producer *" required value={String(loan.producer)}>
              <option value="">Select Producer</option>{producers.map((p, i) => <option key={i} value={String(p.id)}>{p.producerName}</option>)}</AvField></div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="loanDate" label="Loan Date *" type="date" required value={loan.loanDate} /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="loanAmount" label="Loan Amount *" type="text" required value={loan.loanAmount} /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="deductionAmount" label="Deduction *" type="text" required value={loan.deductionAmount} /></div></Col>
          </Row>
          <Row><Col md={12}><div className="mb-3"><AvField name="remarks" label="Remarks" type="textarea" value={loan.remarks} /></div></Col></Row>
          <div className="mb-3 row mt-4">
            <div className="col-6">{submitted && <UncontrolledAlert color="success"><strong>Loan Updated!</strong></UncontrolledAlert>}</div>
            <div className="col-6 text-end"><button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
              {loading ? <><Spinner size="sm" /> <span>Updating...</span></> : <span>Update Loan</span>}</button></div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}
export default EditProducerLoan
